import { RouteComponentProps } from "@reach/router";
import Page from "components/Page";
import React from "react";

import Logo from "../../assets/Logo.png";

export const PdfHeaderPage = (props: RouteComponentProps) => (
  <Page isPublic>
    <Header />
  </Page>
);

const Header = () => (
  <div className="PdfHeaderPage">
    <div className="ReportHeader">
      <img src={Logo} alt="" />
    </div>
  </div>
);
